import { render, staticRenderFns } from "./z5Cell.vue?vue&type=template&id=52e94fb8&scoped=true&"
import script from "./z5Cell.vue?vue&type=script&lang=js&"
export * from "./z5Cell.vue?vue&type=script&lang=js&"
import style0 from "./z5Cell.vue?vue&type=style&index=0&id=52e94fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e94fb8",
  null
  
)

export default component.exports